import * as API from "./base";

const exports = API.crudify("line_item", "/api/line_items");

export const create = exports.create;
export const destroy = exports.destroy;
export const index = exports.index;
export const show = exports.show;
export const update = exports.update;
